namespace $.$$ {
	export class $mol_lights_toggle extends $.$mol_lights_toggle {
		lights( next? : boolean ) {
			return this.$.$mol_lights( next )
		}
	}
}
